module.exports = __webpack_public_path__ + "static/media/ABOUT_BUTTON1.2_EXPLAIN.3fc81dc4.webp";